import React from 'react';
import PropTypes from 'prop-types';

import { videoShape } from '@common/types/cms';

import LinkWrapper from './LinkWrapper';
import { ImageLogo, LazyImage, HeroBadge } from './PageHeroMedia.styled';

const PageHeroMedia = ({ image, badge, logo, link, video, videoDesktop }) =>
  image?.src ? (
    <LinkWrapper link={link}>
      <LazyImage
        alt={image?.alt || ''}
        widths={[1600, 1540, 1366, 1200, 1024, 800, 640, 480, 375]}
        aspectRatios={[
          '16:9',
          '16:9',
          '16:9',
          '16:9',
          '16:9',
          '4:3.2',
          '4:3.2',
          '3.2:4',
          '3.2:4',
        ]}
        src={image?.src}
        dataTestid="mainImg"
        video={video}
        videoDesktop={videoDesktop}
        forceShow
      />
      {logo && <ImageLogo alt={logo?.alt || ''} src={logo?.src} />}
      {badge && <HeroBadge>{badge}</HeroBadge>}
    </LinkWrapper>
  ) : null;

PageHeroMedia.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
  badge: PropTypes.node,
  logo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  link: PropTypes.shape({
    href: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.shape({}),
    }),
    as: PropTypes.string,
  }),
  video: videoShape,
  videoDesktop: videoShape,
};

PageHeroMedia.defaultProps = {
  badge: null,
  logo: null,
  link: {
    href: undefined,
    asHref: undefined,
  },
  video: null,
  videoDesktop: null,
};

export default PageHeroMedia;
